<div class="bp-modal mod-lg">
	<bp-modal-header [title]="'uk_financial_quiz_intro_title' | translate" [cssStyle]="'mod-general border'">
		@if(!isTestNotAppropriate) {
			<a
				right
				(click)="closeClick()"
				(keydown.enter)="closeClick()"
				[tabIndex]="0"
				class="large-weight">
				{{ "close" | translate }}
			</a>
		}
		@if(showBackButton()) {
			<a
				left
				(click)="backClick()"
				(keydown.enter)="backClick()"
				[tabIndex]="0"
				class="large-weight">
				{{ "back" | translate }}
			</a>
		}
	</bp-modal-header>
	<div class="bp-modal-body min-h-560">
		<div class="bp-modal-body-section pl-0 pr-0 pt-40 pb-80">
			<div class="main-content appropriateness-modal">
				<!-- Part 1 - Intro -->
				 @if(isIntroStep()) {
					<ng-container>
						<div class="intro-container">
							<div class="intro-title">{{ "stocks_test_intro_title" | translate }}</div>
							<div class="intro-items-container">
								<div class="intro-item">
									<div class="intro-item__image">
										<img
											class="img-responsive"
											[src]="'/assets/images/customer-segmentation-intro-safety.svg'"
											alt="safe" />
									</div>
									<div class="intro-item__texts">
										<div class="intro-item__texts__title">
											{{ "stocks_test_intro_item_1_title" | translate }}
										</div>
										<div class="intro-item__texts__info">
											{{ "stocks_test_intro_item_1_description" | translate }}
										</div>
									</div>
								</div>
								<div class="intro-item">
									<div class="intro-item__image">
										<img
											class="img-responsive"
											[src]="'/assets/images/customer-segmentation-intro-compliance.svg'"
											alt="compliance" />
									</div>
									<div class="intro-item__texts">
										<div class="intro-item__texts__title">
											{{ "stocks_test_intro_item_2_title" | translate }}
										</div>
										<div class="intro-item__texts__info">
											{{ "stocks_test_intro_item_2_description" | translate }}
										</div>
									</div>
								</div>
							</div>
							<div class="intro-financial-info">{{ "uk_financial_quiz_intro_notification" | translate }}</div>
						</div>
					</ng-container>
				 }
				<!-- Part 2 - Questions -->
				@if(isQuestionsStep()) {
					<ng-container>
						<div class="questions-container">
							<!-- Question step -->
							<div class="question-step-info">{{ getQuestionStepText() }}</div>
							<!-- Questions -->
							@for (question of questionnaire.getQuestions(); track question) {
								<div class="mb-30">
									@if(showQuestion(question)) {
										<div>
											<div class="question-title">{{ question.getQuestion() }}</div>
											@if(!isCodeStep()) {
												<ng-container>
													<!-- Single choice answers -->
													<mat-radio-group
														class="questions-radio-group"
														(change)="onRadioChange($event)"
														name="{{ question.getId() }}">
														@for (answer of question.getAnswers(); track answer) {
															<mat-radio-button
																value="{{ answer.getId() }}"
																class="question-radio"
																[checked]="answer.isSelected()">
																<div class="question-radio-text">{{ answer.getAnswer() }}</div>
															</mat-radio-button>
														}
													</mat-radio-group>
												</ng-container>
											} @else {
												<ng-container>
													<div class="question-input">
														<bp-input
															class="mt-30"
															type="text"
															[(value)]="question.inputValue"
															[placeholder]="question.getInputPlaceholder()"
															[maxlength]="40"
															[showCharCounter]="false"></bp-input>
														<div class="question-input-info">
															{{ "stocks_test_input_info" | translate }}
															<a [href]="getHelpdeskUrl()" target="_blank">
																{{ "stocks_test_input_info_help" | translate }}
															</a>
														</div>
													</div>
												</ng-container>
											}
										</div>
									}
								</div>

							}
						</div>
					</ng-container>
				}
				<!-- Part 3 - Final -->
				@if(isFinalStep()) {
					<ng-container>
						<div class="final-container">
							<div class="final-title mb-0 text-left">{{ "almost_there" | translate }}</div>
							<div class="final-slider-container">
								<bp-switch [model]="finalSlider" field="enabled" [mb]="20" (modelChange)="hasFinalSliderConfirmed($event)">
									<div left class="final-slider-text">{{ "stocks_test_final_slider" | translate }}</div>
								</bp-switch>
							</div>
						</div>
					</ng-container>
				}
				<!-- Part 4 - (optional) if test is not appropriate -->
				@if(isTestNotAppropriate) {
					<ng-container>
						<div class="final-container text-center">
							<div class="final-title">{{ "uk_stocks_test_final_title" | translate }}</div>
							<div class="not-appropriate-text"> {{ "uk_stocks_test_not_appropriate_description" | translate }}</div>
							@if (rejectionType === 'subsequent') {
							<div class="not-appropriate-text">UK regulations require us to impose a 24 hour delay before you may attempt the financial quiz again. During this time, you won’t be able to trade.</div>
							}
							<div class="not-appropriate-text">
								{{ "uk_appropriateness_risk_warning" | translate }}
								@if((accountState$ | async); as accountState) {
									<a
										[href]="academyLink(accountState.language)"
										target="_blank"
									>{{ "uk_go_to_bitpanda_academy" | translate }}</a>
								}
							</div>
						</div>
					</ng-container>
				}
				<div class="button-footer">
					<!-- Continue Button-->
					@if (isTestNotAppropriate) {
						@if(rejectionType === 'first') {
							<div class="bottom-button-container">
								<button
									class="btn btn-primary btn-wide btn-lg mb-0 btn-summary btn-semibold"
									(click)="tryAgain()">
									{{ "try_again" | translate }}
								</button>
							</div>
							<div class="bottom-button-container">
								<button
									class="btn btn-primary btn-wide btn-lg btn-summary"
									[ngClass]="{
										'btn-inverse btn-semibold mb-0': isTestNotAppropriate,
										'mb-20': !isTestNotAppropriate
									}"
									(click)="tryAgain()">
									{{ "got_it_ack" | translate }}
								</button>
							</div>
						} @else if(rejectionType === 'subsequent') {
							<div class="bottom-button-container">
								<button
									class="btn btn-primary btn-wide btn-lg btn-summary"
									[ngClass]="{
										'btn-inverse btn-semibold mb-0': isTestNotAppropriate,
										'mb-20': !isTestNotAppropriate
									}"
									(click)="onContinue()">
									{{ "got_it_ack" | translate }}
								</button>
							</div>
							<div class="bottom-button-container">
								<button
									class="btn btn-primary btn-wide btn-lg mb-0 btn-summary btn-semibold"
									[ngClass]="{ disabled: isButtonDisabled() }"
									(click)="learnMoreClicked()"
									[disabled]="isButtonDisabled()">
									Learn more 
								</button>
							</div>
						}
					} @else {
						<div class="bottom-button-container">
							<button
								class="btn btn-primary btn-wide btn-lg btn-summary"
								[ngClass]="{
									disabled: isButtonDisabled(),
									'btn-inverse btn-semibold mb-0': isTestNotAppropriate,
									'mb-20': !isTestNotAppropriate
								}"
								(click)="onContinue()"
								[disabled]="isButtonDisabled() && !isTestNotAppropriate">
									{{ getButtonKey() | translate }}
							</button>
						</div>
					}
				</div>
			</div>
		</div>
	</div>
</div>
